<script lang="ts" setup>
import { computed } from 'vue';
import { TABS_COUNT, ITEMS_COUNT } from './LoaderTabs.data';
import LoaderItem from './LoaderItem/LoaderItem.vue';

const props = defineProps<{
  darkMode?: boolean;
}>();

const theme = computed(() => (props.darkMode ? 'dark' : 'light'));
</script>

<template>
  <div class="owpi-loader">
    <div class="owpi-loader__tabs">
      <wb-skeleton v-for="index in TABS_COUNT" :key="index" class="owpi-loader__tab" :theme="theme"></wb-skeleton>
    </div>
    <div class="owpi-loader__content">
      <LoaderItem v-for="index in ITEMS_COUNT" :key="index" class="owpi-loader__card" :theme="theme" />
    </div>
  </div>
</template>

<style lang="scss">
.owpi-loader {
  pointer-events: none;
  min-height: var(--vf-calculated-height);

  &__tabs {
    padding: 11px 16px;
    height: 49px;
    border-bottom: 1px solid var(--wb-grey-85);

    @include breakpoint-to(mq2) {
      @include grid(12, false);
    }

    @include breakpoint-from(mq3) {
      display: flex;
      gap: 20px;
    }
  }

  &__tab {
    display: block;
    height: 16px;

    @include breakpoint-to(mq2) {
      @include grid-cell(4);
    }

    @include breakpoint-from(mq3) {
      width: 150px;
    }
  }

  &__content {
    @include grid(12, false);
    padding: var(--wb-spacing-s) 0;
  }

  &__card {
    @include grid-cell(12);

    @include breakpoint-from(mq5) {
      @include grid-cell(6);
    }
  }
}
</style>
